import React, { useState } from 'react';
import styles from './LocaleSwitcher.module.scss';
import i18n from '../../i18n';
import Clickable from '../Clickable';
import { LocaleNames } from '../../enum';

const LocaleSwitcher: React.FC = () => {
  const [lang, setLang] = useState<string>(i18n.language);
  const handleSwitch = () => {
    const result = i18n.language === 'cn' ? 'en' : 'cn';
    i18n.changeLanguage(result);
    localStorage.setItem(LocaleNames.LANG, result);
    setLang(result);
  };
  return (
    <Clickable event={handleSwitch} label="change language">
      <i className={`iconfont ${lang === 'cn' ? 'iconyingwen' : 'iconzhongwen'} ${styles.icon}`} />
    </Clickable>
  );
};

export default LocaleSwitcher;
